module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/cognito-idp-2016-04-18.paginators.json
// module id = 325
// module chunks = 1